import { render, staticRenderFns } from "./AcceptOrder.vue?vue&type=template&id=73d1a4a7&scoped=true"
import script from "./AcceptOrder.vue?vue&type=script&lang=js"
export * from "./AcceptOrder.vue?vue&type=script&lang=js"
import style0 from "./AcceptOrder.vue?vue&type=style&index=0&id=73d1a4a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1a4a7",
  null
  
)

export default component.exports